import React from 'react';
import { Icon } from '@surveycake/rc';
import { IconDefinition } from '@surveycake/rc';
import { angleLeftOutlined } from '@surveycake/rc';
import { angleRightOutlined } from '@surveycake/rc';
import {
  GoPrevPageService,
  GoNextPageService,
  IGoPageService
} from 'app/modules/survey';
import { userAgent } from 'config/system';
import { useArrowStyles } from './styles';

function createArrow(icon: IconDefinition, GoPageService: IGoPageService) {
  return function Arrow() {
    const goPrevOrNextPage = GoPageService.useGoPage();
    const [disabled, visible] = GoPageService.useGoPageStatus();
    const styles = useArrowStyles([disabled]);

    if (!visible) {
      return null;
    }

    const onTouchEnd = () => {
      goPrevOrNextPage();
    };

    const onClick = () => {
      goPrevOrNextPage();
    };

    return (
      <div
        className={styles.arrow}
        {...{
          ...(userAgent.isIOS && !disabled  && { onTouchEnd }),
          ...(!userAgent.isIOS && !disabled  && { onClick }),
        }}
      >
        <Icon icon={icon} />
      </div>
    );
  };
}

export const Prev = createArrow(angleLeftOutlined, GoPrevPageService);
export const Next = createArrow(angleRightOutlined, GoNextPageService);
